/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, useState, useContext } from 'react';
import { IonToast } from '@ionic/react';
import { Ionic, UXComponent, Web } from '../../components/UXComponent';
import { toast, ToastContainer } from 'react-toastify';
import { EComponentType, useAppSettings } from '../appSettings';
const store = createContext({ state: {}, setState: () => null });
const { Provider } = store;
const ToastProvider = (props) => {
    const [state, setState] = useState({});
    return React.createElement(Provider, { value: { state, setState } },
        React.createElement(UXComponent, null,
            React.createElement(Ionic, null,
                React.createElement(IonToast, { isOpen: state.show || false, onDidDismiss: () => setState(Object.assign(Object.assign({}, state), { show: false })), message: state.message, position: state.position || 'bottom', duration: state.duration || 2000, color: state.color })),
            React.createElement(Web, null,
                React.createElement(ToastContainer, null))),
        props.children);
};
function useToast() {
    const toastContext = useContext(store);
    const { settings } = useAppSettings();
    const showToast = (props) => {
        if (settings['componentType'] === EComponentType.Web) {
            toast(props.message, {
                position: props.position,
                autoClose: props.duration || 2000,
                hideProgressBar: !(props.showProgressBar === true),
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                style: props.style,
                bodyStyle: props.bodyStyle,
                bodyClassName: props.bodyClassName,
                className: props.className,
                type: props.type
            });
            return;
        }
        toastContext.setState(Object.assign(Object.assign({}, props), { show: true }));
    };
    return {
        showToast: showToast
    };
}
export { store as ToastStore, ToastProvider, useToast };
//# sourceMappingURL=index.js.map